var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-popover"},[_c('div',{staticClass:"status-popover__list"},_vm._l((_vm.filteredOptions),function(option){return _c('button',{key:option.id,staticClass:"status-button",on:{"click":function($event){return _vm.selectOption(option)}}},[_c('StatusCell',{attrs:{"status":option.id}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }